/**
 * @fileoverview This script observes changes to the cart by monitoring network requests
 * and recalculates the remaining amount needed for free shipping whenever the cart is updated.
 * @author: Shawn Rego <shawn@hyperit.com.au>
 */


/**
 * Observes network requests and triggers the recalculation of shipping if the request is related to cart changes.
 * @param {PerformanceObserverEntryList} list - The list of performance entries.
 */
const cartObserver = new PerformanceObserver(async (list) => {
  for (const entry of list.getEntries()) {
    const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
    const isCartChangeRequest = /\/cart\//.test(entry.name);
    if (isValidRequestType && isCartChangeRequest) {
      try {
        const cartTotal = await getCartSubTotal();
          freeship(cartTotal);
        // You can now use cartTotal for further processing
      } catch (error) {
        console.error('Error getting cart total:', error);
      }
    }
  }
});
cartObserver.observe({ entryTypes: ["resource"] });

/**
 * Gets the current subtotal of the cart using the Shopify REST API
 */
async function getCartSubTotal() {
  const endPoint = "https://www.itchybabyco.com.au/cart.js";
 
  try {
    const response = await fetch(endPoint);
    
    if (!response.ok) {
      throw new Error("Error loading cart data");
    }
    
    const cartData = await response.json();
    return cartData.items_subtotal_price;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

/**
 * Updates the UI to reflect the shipping
 * Adapted from the freeship function in theme.js
 */
function freeship(cartTotal){
  var freeshipPrice = $(".freeShipMsg").attr('data-price');
  remainfreeship = freeshipPrice - cartTotal;
  
  if(remainfreeship>0){
     $(".freeShipMsg .freeShip").html(theme.Currency.formatMoney(remainfreeship, theme.moneyFormat));
     $(".freeShipMsg").show(); $('.freeShipclaim').hide();
     if(theme.mlcurrency){currenciesChange(".freeShipMsg .freeShip sapn.money");}
  } else {
     $(".freeShipMsg").hide(); $('.freeShipclaim').show();
  }
}